module.exports = "<div *ngIf=\"selectedFav\">\n  <h2>{{selectedFav.name }}</h2>\n  <form id=\"notes-form\">\n    <textarea rows=\"4\" type=\"textarea\" name=\"notes\" [(ngModel)]=\"selectedFav.notes\" class=\"form-control\"></textarea><br>\n    <button type=\"button\" name=\"button\" (click)=\"addNote(selectedFav.$key, selectedFav.notes)\" class=\"btn\">UPDATE</button>\n  </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Food-Savor/src/app/modal/modal.component.html
// module id = ../../../../../src/app/modal/modal.component.html
// module chunks = main